import { Colors, Services, isEmpty } from '@sigma-frontend-libs/commons'

import { buttonModes, components, icons } from '@/utils'

import button from '@/components/button'
import squircle from '@/components/icon/squircle'
import info from '@/components/info'
import arrow from '@/components/misc/arrow'
import sendingsCreateForm from '@/components/services/sendingsCreate/form'
import fallbackOptions from '@/components/services/sendingsCreate/form/fallback/options'
import sticker from '@/components/sticker'

function renderSender(h, value) {
  return h(
    sticker,
    {
      props: {
        value: value?.payload?.sender,
        label: this.getTranslate(`${Services.sendings}.labels.sender`),
        color: Colors[value?.type],
        iconSVG: value?.type
      }
    }
  )
}
function renderTextSticker(h, value) {
  if (this.viewport.size.width >= 600) {
    if (!isEmpty(value?.payload?.text)) {
      return h(
        sticker,
        {
          props: {
            value: value.payload.text,
            label: this.getTranslate(`${Services.sendings}.labels.text`)
          }
        }
      )
    }

    return h('div', { class: 'ff' })
  }
}
function renderValidationIcon(h, value, validation = true) {
  if (!validation) {
    return h(
      squircle,
      {
        props: {
          icon: icons.info_outline,
          color: Colors.warning,
          tooltip: this.getTranslate(`${Services.sendings}.tooltips.validation`)
        }
      }
    )
  }

  return h('div')
}
function renderArrow(h, expanded) {
  return h(arrow, { props: { expanded } })
}
function renderHeader(h, value, validation, expanded) {
  if (value) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__fallbacks-panel-header`
      },
      [
        renderSender.call(this, h, value),
        renderTextSticker.call(this, h, value),
        renderValidationIcon.call(this, h, value, validation),
        renderArrow.call(this, h, expanded)
      ]
    )
  }
}
function renderSendingsCreateForm(h, value) {
  return h(
    sendingsCreateForm,
    {
      props: {
        value,
        isFallback: true,
        applyingTemplate: this.applyingTemplate,
        service: this.service,
        disabled: this.disabled,
        readonly: this.readonly
      }
    }
  )
}
function renderBasePanel(h) {
  return h(
    components['expansion-panel'],
    {
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, this.proxy, this.isValidPayload, expanded)
        }
      }
    },
    [
      h(
        'div',
        {
          class: `${Services.sendings}-create__fallbacks-panel`
        },
        [ renderSendingsCreateForm.call(this, h, this.proxy) ]
      )
    ]
  )
}
function renderWarning(h, validation) {
  if (!validation) {
    return h(
      info,
      {
        props: {
          value: this.getTranslate(`${Services.sendings}.warnings.fallbacks.validation`),
          color: Colors.warning
        }
      }
    )
  }
}
function renderOptions(h, value) {
  return h(
    fallbackOptions,
    {
      props: {
        value: value.$options,
        readonly: this.readonly
      },
      on: {
        input: event => {
          value.$options = event
        }
      }
    }
  )
}
function renderRemoveButton(h, index) {
  if (!this.disabled || !this.readonly) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__fallbacks-button`
      },
      [
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.remove'),
              mode: buttonModes.flat,
              color: Colors.error,
              disabled: this.disabled
            },
            on: {
              click: () => {
                this.removeFallback(index)
              }
            }
          }
        )
      ]
    )
  }
}
function renderFallbackPanel(h, item, index) {
  return h(
    components['expansion-panel'],
    {
      attrs: { id: `fallback-${index}` },
      on: {
        mounted: () => {
          return this.scrollToPanel(index)
        }
      },
      scopedSlots: {
        header: ({ expanded }) => {
          return renderHeader.call(this, h, item, this.isValidFallbacks[index], expanded)
        }
      },
      ref: `fallback-${index}`,
      key: `fallback-${index}`
    },
    [
      h(
        'div',
        {
          class: `${Services.sendings}-create__fallbacks-panel`
        },
        [
          renderSendingsCreateForm.call(this, h, item),
          renderWarning.call(this, h, this.isValidFallbacks[index]),
          renderOptions.call(this, h, item),
          renderRemoveButton.call(this, h, index)
        ]
      )
    ]
  )
}
function renderFallbacksPanels(h) {
  return this.proxy.fallbacks.map((item, index) => {
    return renderFallbackPanel.call(this, h, item, index)
  })
}
function renderPanels(h) {
  if (this.proxy.fallbacks.length) {
    return h(
      components['expansion-panels'],
      {
        props: {
          flat: true,
          outline: true,
          rounded: true
        }
      },
      [
        renderBasePanel.call(this, h),
        renderFallbacksPanels.call(this, h)
      ]
    )
  }
}

function renderButton(h) {
  if (!this.disabled || !this.readonly) {
    return h(
      'div',
      {
        class: `${Services.sendings}-create__fallbacks-button`
      },
      [
        h(
          button,
          {
            props: {
              label: this.getTranslate('misc.buttons.fallback'),
              icon: icons.add,
              mode: buttonModes.outline,
              color: Colors.primary,
              disabled: this.$_disabled
            },
            on: {
              click: () => {
                this.add()
              }
            }
          }
        )
      ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services.sendings}-create__fallbacks`
    },
    [
      renderPanels.call(this, h),
      renderButton.call(this, h)
    ]
  )
}
